
import { NgxLoggerLevel } from 'ngx-logger';

export const environment = {
  production: true,
  defaultauth: 'fackbackend',
  firebaseConfig: {
    apiKey: '',
    authDomain: '',
    databaseURL: '',
    projectId: '',
    storageBucket: '',
    messagingSenderId: '',
    appId: '',
    measurementId: '',
  },


  api:'https://multiubicacion.scvplatform.com/api/',


  // api:'http://localhost:3000/api/',
  
//  T%Z6G5CTc4y?3wl
//  $Pm*PYiJPU%IX
// LGe3nrm3@225
  
  
 


  idleTimeInMinutes: 5,
  logLevel: NgxLoggerLevel.OFF,
  serverLogLevel: NgxLoggerLevel.ERROR,
  

};
